import { initializeApp } from "firebase/app"
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth"
import { FIREBASE_CONFIG } from "./constants"

// Initialize Firebase
const firebase = initializeApp(FIREBASE_CONFIG)
const auth = getAuth(firebase)

const login = (email, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      await signInWithEmailAndPassword(auth, email, password)
      resolve()
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

const logout = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await signOut(auth)
      resolve()
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

export { auth, login, logout }
